module.exports = __webpack_public_path__ + "img/knowledge_robot.b32994b1.svg";